module.exports = __webpack_public_path__ + "static/media/bg16.b13268e9.jpg";